import { all } from 'route-data/all';
import { chain } from 'route-data/chain';
import { SITE_WIDE_BANNER } from 'constants/experience-fragments';
import cmsExperienceFragment from 'redux/fetchers/experience-fragment';
import { minimumOrderValuesFetcher } from 'redux/fetchers/minimum-order-values';
import { addressesFetcher } from 'redux/fetchers/address/addressesFetcher';
import loggedInCustomerDataFetcher from 'redux/fetchers/logged-in-customer-data';

export const createFetcherChain = ({
  blockingFetchers,
  fetchersAfterLoggedInCustomerData,
  fetchersInParallel,
}: {
  blockingFetchers?: unknown;
  fetchersAfterLoggedInCustomerData?: unknown;
  fetchersInParallel?: unknown;
}) => {
  const fetchers = all(
    ...(fetchersInParallel ? [fetchersInParallel] : []),
    cmsExperienceFragment(SITE_WIDE_BANNER.key),
    chain(
      loggedInCustomerDataFetcher,
      // minimumOrderValuesFetcher after loggedInCustomerDataFetcher as it does nothing if the get trolley request returns i.e. when logged in
      fetchersAfterLoggedInCustomerData
        ? all(fetchersAfterLoggedInCustomerData, minimumOrderValuesFetcher)
        : minimumOrderValuesFetcher,
    ),
    addressesFetcher,
  );

  return blockingFetchers ? chain(blockingFetchers, fetchers) : fetchers;
};
